import { Routes, RouterModule } from '@angular/router';
import { ClientsComponent } from './clients.component';
import { NgModule } from '@angular/core';
import { ClientProfileComponent } from './profile/profile.component';

const routes: Routes = [{
	path: '',
	data: {
		title: 'Clientes',
		status: false,
		breadcrumb: "Clientes"
	},
	children: [
		{
			path: '',
			component: ClientsComponent
		},
		{
			path: 'profile/:id',
			component: ClientProfileComponent,
			data: {
				breadcrumb: 'Perfil',
				status: true
			}
		}
	]
}];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class ClientsRoutingModule {}


// WEBPACK FOOTER //
// ./src/app/components/clients/clients-routing.module.ts